/*******************************************************************
* PAGE        : UserRightsForm
* REMARKS     :
* CREATED ON  : 09-09-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 09-09-2026
********************************************************************/

import React, { useEffect, useState } from 'react';
import LoaderComponent from '../../components/LoaderComponent/LoaderComponent';
import DialogComponent from '../../components/DialogComponent/DialogComponent';
import NotificationComponent from '../../components/NotificationComponent/NotificationComponent';
import { AddUpdateUserRightMaster, GetScreenMasterList } from '../../services/apiController';
import CheckboxComponent from '../../components/CheckboxComponent/CheckboxComponent';

// #region Component
const UserRightsForm = ({ openPopup, selectedData = {}, handleClose }) => {

    // #region States
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [screenMasterList, setScreenMasterList] = useState([]);
    const [originalScreenMasterList, setOriginalScreenMasterList] = useState([]);

    const [errors, setErrors] = useState({}); // To store validation errors
    const [formData, setFormData] = useState({
        eventMasterId: selectedData?.TicketMasterId || 0,
        userName: selectedData?.UserName || '',
        selectedOptions: [],
    });

    const [snackbarStates, setSnackbarStates] = useState({ isSnackbarOpen: false, snackbarMessage: '' });
    const handleCloseSnackbar = () => {
        setSnackbarStates({ isSnackbarOpen: false, snackbarMessage: '', snackbarSeverity: '' });
    };
    // #endregion

    useEffect(() => {
        wsGetScreenMasterList();
    }, [])

    const wsGetScreenMasterList = async () => {
        setLoading(true);
        try {
            const response = await GetScreenMasterList({ userMasterId: selectedData?.TicketUserMasterId });

            const screens = response?.screens || [];

            setScreenMasterList(screens);

            // Keep untouched copy for comparison
            setOriginalScreenMasterList(screens);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    const wsAddUpdateUserRightMaster = async () => {
        setIsLoading(true);

        const userScreenRights = screenMasterList
            .filter((current) => {
                const original = originalScreenMasterList.find((item) => item.ScreenMasterId === current.ScreenMasterId);

                // Only include when HasAccess changed
                return original?.HasAccess !== current.HasAccess;
            })
            .map((current) => {
                const original = originalScreenMasterList.find((item) => item.ScreenMasterId === current.ScreenMasterId);

                return {
                    userRightMasterId: original?.UserRightMasterId || 0,
                    ticketUserMasterId: selectedData?.TicketUserMasterId || 0,
                    screenMasterId: current.ScreenMasterId,
                    isDelete: !current.HasAccess
                };
            });

        const params = { userScreenRights };

        AddUpdateUserRightMaster(params)
            .then((response) => {
                if (response?.status) {
                    setSnackbarStates({ isSnackbarOpen: true, snackbarMessage: response?.message || "User rights updated successfully", snackbarSeverity: "success" });
                    setTimeout(() => {
                        handleClose();
                        setIsLoading(false);
                    }, 3000);
                } else {
                    setSnackbarStates({ isnackbarOpen: true, snackbarMessage: response?.message || "Unable to update user rights", snackbarSeverity: "error" });
                    setIsLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setIsLoading(false);
            });
    };


    // #region Methods

    // #endregion

    return (loading ? <LoaderComponent />
        : <React.Fragment>
            <NotificationComponent isOpen={snackbarStates.isSnackbarOpen} message={snackbarStates.snackbarMessage} onClose={handleCloseSnackbar} severity={snackbarStates.snackbarSeverity} />
            <DialogComponent
                isOpen={openPopup}
                Title="User Rights"
                maxWidth={'sm'}
                ActionText={"Save"}
                IsLoading={isLoading}
                onSave={wsAddUpdateUserRightMaster}
                onClose={handleClose}
            >
                <form onSubmit={wsAddUpdateUserRightMaster}>
                    <div style={{ marginBottom: '20px' }}>

                        {screenMasterList?.map((option) => (
                            <CheckboxComponent
                                key={option.ScreenMasterId}
                                id={`screen-${option.ScreenMasterId}`}
                                label={option.ScreenCaption}
                                checked={option.HasAccess}
                                onChange={(e) => {
                                    setScreenMasterList((prev) =>
                                        prev.map((item) =>
                                            item.ScreenMasterId === option.ScreenMasterId
                                                ? { ...item, HasAccess: e.target.checked }
                                                : item
                                        )
                                    );
                                }}
                            />
                        ))}

                    </div>
                </form>
            </DialogComponent>
        </React.Fragment>
    );
};
// #endregion

export default UserRightsForm;